const AUDIO_PATH = '/__rs_audio__/';
const KNOWN_EXTENSIONS = /\.(aac|flac|m4a|mp3|oga|ogg|opus|wav|webm)$/i;

function extensionOf(source: URL): string {
  return source.pathname.match(KNOWN_EXTENSIONS)?.[0]?.toLowerCase() ?? '.mp3';
}

/**
 * Convierte una dirección firmada y temporal en una dirección local estable.
 *
 * El identificador lógico queda en la ruta y es la clave persistente. La URL
 * firmada viaja como parámetro únicamente para que el service worker tenga de
 * dónde descargar cuando todavía no guardó el archivo.
 */
export function cacheableAudioUrl(cacheId: string, signedUrl: string): string {
  // En la primera visita el worker puede estar instalándose todavía. En ese
  // intervalo la dirección local llegaría al servidor web y devolvería 404;
  // se usa la firma directa para que el audio nunca dependa de la caché.
  if (!navigator.serviceWorker?.controller) return signedUrl;
  const source = new URL(signedUrl, window.location.href);
  const identity = encodeURIComponent(cacheId.trim() || source.pathname);
  const local = new URL(`${AUDIO_PATH}${identity}${extensionOf(source)}`, window.location.origin);
  local.searchParams.set('source', source.href);
  return `${local.pathname}${local.search}`;
}
